export default __webpack_public_path__ + "static/media/010-compass.aee78f9c.svg";